// From http://www.redblobgames.com/
// Copyright 2015 Red Blob Games <redblobgames@gmail.com>
// License: Apache v2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>

/** Render to both a 2D and 3D canvas */

import Renderer2D from "./render2d.js";
import Renderer3D from "./render3d.js";

export default class Renderer {
    constructor(elementId, map, colorMap) {
        this.r2 = new Renderer2D(elementId + "-2d", map, colorMap);
        this.r3 = new Renderer3D(elementId + "-3d", map, colorMap);
    }
    
    draw() {
        this.r2.draw();
        this.r3.draw();
    }
}
